import { render, staticRenderFns } from "./MarkSheetRow.vue?vue&type=template&id=2bf2720c&scoped=true&"
import script from "./MarkSheetRow.vue?vue&type=script&lang=js&"
export * from "./MarkSheetRow.vue?vue&type=script&lang=js&"
import style0 from "./MarkSheetRow.vue?vue&type=style&index=0&id=2bf2720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2720c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressCircular,VTextField,VTextarea,VTooltip})
